export type Handler<T = any> = (event: string, payload?: T) => void | Promise<void>;
export class Bus {
  private map = new Map<string, Set<Handler>>();
  private monitors = new Set<Handler>();
  monitor(h: Handler) { this.monitors.add(h); return () => this.monitors.delete(h); }
  on(event: string, h: Handler) { if (!this.map.has(event)) this.map.set(event, new Set()); this.map.get(event)!.add(h); return () => this.off(event, h); }
  off(event: string, h: Handler) { this.map.get(event)?.delete(h); }
  async emit(event: string, payload?: any) { for (const h of this.monitors) {await h(event, payload);};const hs = this.map.get(event); if (!hs) return; for (const h of hs) await h(event, payload); }
}
